import { FormikDropdown } from '../../../../components/form-components/common-components/dropdown/FormikDropdown';
import { FormikTextField } from '../../../../components/form-components/common-components/text-field/FormikTextField';
import type { AppointmentFormValues } from '../../../../models/appointment/AppointmentModel';
import { AppointmentTimeFields } from './AppointmentTimeFields';
import { appointmentFieldIcons as AI } from './appointmentFieldIcons';
import styles from './NewAppointmentPopup.module.css';

type AppointmentEditFormFieldsProps = {
  hospitalOptions: Array<{ value: number; label: string }>;
  personOptions: Array<{ value: number; label: string }>;
  userOptions: Array<{ value: string; label: string }>;
  hospitalId: number | null;
};

const AppointmentEditFormFields = ({
  hospitalOptions,
  personOptions,
  userOptions,
  hospitalId,
}: AppointmentEditFormFieldsProps) => {
  return (
    <>
      <div className={styles.inputContainer}>
        <FormikDropdown
          name="hospitalId"
          options={hospitalOptions}
          label="Hastane"
          startIcon={AI.hospital}
          required
        />
      </div>

      <div className={styles.inputContainer}>
        <FormikTextField
          name="requestNumber"
          label="Etiket Numarası"
          placeholder="Etiket numarasını giriniz"
          startIcon={AI.tag}
          disabled
        />
      </div>

      <div className={styles.inputContainer}>
        <FormikDropdown
          name="personId"
          options={personOptions}
          label="Kişi"
          placeholder="Önce hastane seçiniz"
          startIcon={AI.person}
          disabled={!hospitalId}
          required
        />
      </div>

      <div className={styles.inputContainer}>
        <FormikDropdown
          name="userId"
          options={userOptions}
          label="Kullanıcı"
          placeholder="Kullanıcı seçiniz"
          startIcon={AI.user}
        />
      </div>

      <div className={styles.inputContainer}>
        <FormikTextField
          name="appointmentDate"
          label="Randevu Tarihi"
          type="date"
          placeholder="Tarih seçiniz"
          startIcon={AI.appointmentDate}
          required
        />
      </div>

      <AppointmentTimeFields />

      <div className={styles.inputContainer}>
        <FormikTextField
          name="deviceList"
          label="Cihaz Listesi"
          placeholder="Cihaz listesini giriniz"
          multiline
          rows={4}
          disableUppercase
          startIcon={AI.deviceList}
          required
        />
      </div>
    </>
  );
};

export default AppointmentEditFormFields;
